module.exports = __webpack_public_path__ + "img/menu-hair-13.83592ec4.webp";